/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {WarningsEnum} from '../warnings.enum';

@Component({
    selector: 'app-warning-inline',
    templateUrl: './warning-inline.component.html',
    styleUrls: [
        './warning-inline.component.css',
        '../warnings.css'
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class WarningInlineComponent {

    @Input() warningInlineLabel: string;
    @Input() warningInlineLabelsArray: string[];
    /** Variable to determine the severity of the warning. Default value {@link WarningsEnum.WARNING} **/
    @Input() warningType: WarningsEnum = WarningsEnum.WARNING;
    WarningsEnum = WarningsEnum;
    private readonly iconClass: ReadonlyMap<WarningsEnum, string> = new Map([
        [WarningsEnum.ERROR, 'iwp-icon-pc_info_warning'],
        [WarningsEnum.WARNING_SEND, 'iwp-icon-gen_info_warning'],
        [WarningsEnum.WARNING, 'iwp-icon-gen_info_warning'],
        [WarningsEnum.WARNING_CUSTOM, 'iwp-icon-gen_info_warning'],
        [WarningsEnum.INFO, 'iwp-icon-gen_info_info']
    ]);
    private readonly colorClass: ReadonlyMap<WarningsEnum, string> = new Map([
        [WarningsEnum.ERROR, 'color-error'],
        [WarningsEnum.WARNING_SEND, 'color-warning-send'],
        [WarningsEnum.WARNING, 'color-warning'],
        [WarningsEnum.WARNING_CUSTOM, 'color-warning'],
        [WarningsEnum.INFO, 'color-info']
    ]);

    getIconClass(): string[] {
        return [this.iconClass.get(this.warningType), this.colorClass.get(this.warningType)];
    }

    getColorClass(): string {
        return this.colorClass.get(this.warningType);
    }

    hasIcon(): boolean {
        return this.iconClass.has(this.warningType);
    }
}
